const TicketHistory=(props)=>{
    const handleRouteClick = (params) => {
        props.onShowTicketHistory(props);
    };
    return (
        <a onClick={handleRouteClick} title="Ticket History"><i className="fa fa-history f20"></i></a>
    );
}
export default TicketHistory